import { SearchBar, Heading, HeadingEnum, BoldEnum } from '@desquared/wave-components-library';
import { useState } from 'react';
import { useDebouncedValue } from '@/hooks/useDebouncedValue';
import { getCategoryPathArrayFromSlug, sortByPosition } from '@/utils/category';
import { trimmCategories } from '@/utils/trimmCategories';
import CategoriesMenu from '@/components/CategoriesMenu/CategoriesMenu';
import styles from './FullEditCatalogue.module.css';
import { EditCatalogue } from './EditCatalogue/EditCatalogue';
import { SearchCatalogue } from './SearchCatalogue/SearchCatalogue';
import { useTranslations } from 'next-intl';
import useDisableBodyScroll from '@/hooks/useDisableBodyScroll';

export function FullEditCatalogue({ categoriesFromFile, onSelect, selectedOrder }) {
  const t = useTranslations();

  const [query, setQuery] = useState('');
  const debouncedQuery = useDebouncedValue(query, 500);
  // This is what handles what route is being displayed. The setRoute will change the displayed catalogue
  const [route, setRoute] = useState({
    slug: sortByPosition(categoriesFromFile)[0].slug.split('/'),
    subcategory: undefined,
  });

  const selectedCategoryInfo = getCategoryPathArrayFromSlug(categoriesFromFile, route.slug);
  const selectedCategoryTree = selectedCategoryInfo.categories;

  const selectedCategoryId = selectedCategoryTree[selectedCategoryTree.length - 1]._id;
  const { normalCategories, featuredCategories } = trimmCategories(
    categoriesFromFile,
    t('category_details.all_categories')
  );
  const sortedNormalCategories = sortByPosition(normalCategories);
  const sortedFeaturedCategories = sortByPosition(featuredCategories);
  const allCategories = [...sortedFeaturedCategories, ...sortedNormalCategories];
  const currentCategory = selectedCategoryTree[selectedCategoryTree.length - 1];
  const subCategories = selectedCategoryInfo.subCategories;
  useDisableBodyScroll();
  return (
    <section className={styles.container}>
      <div className={styles.searchBarContainer}>
        <Heading type={HeadingEnum.HeadingM} bold={BoldEnum.Bold} classOption={styles.heading}>
          {t('common.asides.side_cart.search_products_header')}
        </Heading>
        <SearchBar
          isRound
          hasContainer
          text={t('common.asides.search_product.search_placeholder')}
          classOption={styles.searchBar}
          value={query}
          setValue={setQuery}
        />
      </div>

      <div className={styles.mainContainer}>
        <div className={styles.catalogueContainer}>
          <div>
            <CategoriesMenu
              categories={allCategories}
              slug={route.slug}
              featuredAmmount={featuredCategories.length}
              selectedCategoryTree={selectedCategoryTree}
              routeSetter={routeData => {
                if (query) setQuery('');
                setRoute(routeData);
              }}
              sideMenuStyles={{ position: 'sticky', top: 0 }}
            />
          </div>

          {!debouncedQuery ? (
            <EditCatalogue
              selectedCategoryId={selectedCategoryId}
              categoriesFromFile={categoriesFromFile}
              currentCategory={currentCategory}
              subCategories={subCategories}
              selectedCategoryTree={selectedCategoryTree}
              route={route}
              setRoute={setRoute}
              onSelect={onSelect}
              selectedOrder={selectedOrder}
            />
          ) : (
            <SearchCatalogue query={debouncedQuery} categoriesFromFile={categoriesFromFile} onSelect={onSelect} />
          )}
        </div>
      </div>
    </section>
  );
}
